import {Box, Typography} from "@mui/material";
import * as React from "react";
import PropTypes from "prop-types";

const QuestionDescription = ({description}) => {
  return (
    <Box>
      {description.split("\n").join("\\n").split("\\n").map((str, idx) =>
        <Typography align="justify" key={idx}>{str}</Typography>)}
    </Box>
  );
};

export default QuestionDescription;

QuestionDescription.propTypes = {
  description: PropTypes.string
}